import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/Card/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import { useCategory } from '../../CategoryContext';

import BackButton from '../../components/BackButton';

import { Context } from '../../AuthContext';

import AlertDialog from '../../components/AlertDialog';
import { useDeleteContent } from './useDeleteContent';

const PatentPage = ({ category = 'patent' }) => {
  const { updateCount, isEditor } = useCategory();
  const { handleDelete } = useDeleteContent();

  const { user } = useContext(Context);

  const icons = {
    // 'inventors': <PeopleOutlinedIcon className='detail-icon' style={{color: 'green'}}/>,
    publication_number: <BookOutlinedIcon className="detail-icon" />,
    publication_date: <CalendarMonthOutlinedIcon className="detail-icon" />,
    assignee_original: (
      <AccountBalanceOutlinedIcon className="detail-icon" style={{ color: '#AB6EF9' }} />
    ),
  };

  const [show, setShow] = useState();
  const navigate = useNavigate();

  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(true);

  const { vertical_id, id } = useParams();

  useEffect(() => {
    if (!user) return;

    const getItem = async () => {
      const item = await fetchItem();
      if (!item) return;
      setItem(item.data);
      document.title = item.data.title + ' - The Simple Platform';
      setShow(item.data.show);
      setLoading(false);
    };
    getItem();
  }, [id, user, vertical_id]);

  const fetchItem = async () => {
    const token = await user.getIdToken();
    const url =
      process.env.REACT_APP_FLASK_WEBSERVER +
      `get_${category}_details?id=${id}&vertical_id=${vertical_id}`;

    const itemRequest = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (itemRequest.status === 403) {
      navigate('/forbidden', { replace: true });
      return null;
    }
    const item = await itemRequest.json();

    const bookmark_status_endpoint =
      process.env.REACT_APP_FLASK_WEBSERVER + `get_bookmark_id/${item?.data?._id}`;
    const bookmarkRequest = await fetch(bookmark_status_endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const bookmark = bookmarkRequest.ok ? await bookmarkRequest.json() : { isBookmarked: false };

    const result = {
      ...item,
      data: {
        ...item.data,
        isBookmarked: bookmark.isBookmarked,
      },
    };

    return result;
  };

  function editContent(event) {
    event.stopPropagation();
    navigate('edit');
  }

  const toggleBookmark = async (event, itemId, category) => {
    event.stopPropagation();
    setItem({ ...item, isBookmarked: !item.isBookmarked });

    try {
      let vid = vertical_id;
      const token = await user.getIdToken();

      await fetch(`${process.env.REACT_APP_FLASK_WEBSERVER}toggle_bookmark`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: user.uid,
          item_id: itemId,
          category: `${category}s`,
          vertical_id: vid,
        }),
      });
    } catch (error) {
      console.error('Failed to toggle bookmark:', error);
    }
  };

  const hideContent = async (event) => {
    event.stopPropagation();
    if (!user) return;

    const isChecked = !show;
    if (isChecked) {
      updateCount(category + 's', 1);
    } else {
      updateCount(category + 's', -1);
    }
    setShow(isChecked);
    const token = await user.getIdToken();

    const res = await fetch(
      process.env.REACT_APP_FLASK_WEBSERVER +
        'change_visibility?id=' +
        item._id +
        '&collection=' +
        category +
        's&vertical_id=' +
        vertical_id,
      {
        method: 'PATCH',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ show: isChecked }),
      }
    );
    await res.json();
  };

  let urlPrefix = '/vertical/' + vertical_id + '/';

  return loading ? (
    <Spinner />
  ) : (
    <div style={{ width: '75%', textAlign: 'left' }}>
      <BackButton />
      <h4 style={{ color: '#596274' }}>PATENT</h4>

      <div className="detail-card">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {item?.title && <h2 className="detail-title">{item.title}</h2>}

          {item?.status === 'approved' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: 0,
                margin: 0,
              }}
            >
              {isEditor && item?.status === 'approved' && (
                <div style={{ display: 'flex', alignItems: 'center', padding: 0, margin: 0 }}>
                  {show ? (
                    <Tooltip title="Visible to Members">
                      <VisibilityOutlinedIcon
                        style={{ color: '#356AC3' }}
                        className="detail-icon clickable"
                        onClick={(event) => hideContent(event)}
                        aria-label="Content is visible"
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Hidden To Members">
                      <VisibilityOffOutlinedIcon
                        style={{ color: '#356AC3' }}
                        className="detail-icon clickable"
                        onClick={(event) => hideContent(event)}
                        aria-label="Content is hidden"
                      />
                    </Tooltip>
                  )}
                  <FontAwesomeIcon
                    color="#356AC3"
                    icon={faPenToSquare}
                    className="detail-icon clickable"
                    onClick={(event) => editContent(event)}
                  ></FontAwesomeIcon>
                  <AlertDialog
                    id={item._id}
                    action={() =>
                      handleDelete({
                        id: item._id,
                        collection: category + 's',
                        verticalId: vertical_id,
                        parent_id: item?.publication_number,
                        otherIds: item?.inventors?.map((inventor) => inventor.name) ?? [],
                        bookmarked: item?.isBookmarked,
                      })
                    }
                    index={-1}
                    dialogTitle={`Delete ${category}: ${item?.title}`}
                    dialogContentText={`This action cannot be undone. This will permanently delete the ${category} and remove the data from our servers.`}
                    color="blue"
                  />
                </div>
              )}
              {item?.status === 'approved' &&
                (item?.isBookmarked ? (
                  <BookmarkIcon
                    className="detail-icon clickable"
                    onClick={(e) => toggleBookmark(e, item._id, `${category}`)}
                    style={{ color: '#356AC3' }}
                  />
                ) : (
                  <BookmarkBorderIcon
                    className="detail-icon clickable"
                    onClick={(e) => toggleBookmark(e, item._id, category)}
                    style={{ color: '#356AC3' }}
                  />
                ))}
            </div>
          )}
        </div>

        {item?.inventors?.length > 0 && (
          <div className="detail-item" style={{ color: 'green' }}>
            <PeopleOutlinedIcon className="detail-icon-" />
            <div className="people">
              {item.inventors.map((inventor, index) => (
                <div key={index}>
                  <Link to={`${urlPrefix}inventor/${inventor.name}`}>
                    <span>{inventor.name}</span>
                  </Link>
                  {index < item.inventors.length - 1 && <span>,&nbsp;</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        {item?.assignees?.length > 0 && (
          <div className="detail-item">
            <AccountBalanceOutlinedIcon className="detail-icon-" style={{ color: '#AB6EF9' }} />
            <div className="people">
              {item.assignees.map((assignee, index) => (
                <span key={index}>
                  {assignee}
                  {index < item.assignees.length - 1 && <span>,&nbsp;</span>}
                </span>
              ))}
            </div>
          </div>
        )}

        {item?.publication_number && (
          <div className="detail-item">
            <BookOutlinedIcon className="detail-icon-" />
            {item.publication_number}{' '}
            {item?.application_number && '(' + item.application_number + ')'}
          </div>
        )}

        {(item?.priority_date ||
          item?.filing_date ||
          item?.grant_date ||
          item?.publication_date) && (
          <div className="detail-item">
            <CalendarMonthOutlinedIcon className="detail-icon-" />
            {item.publication_date && (
              <span>Published: {item.publication_date}&nbsp;&#x2022;&nbsp;</span>
            )}
            {item.priority_date && <span>Priority: {item.priority_date}&nbsp;&#x2022;&nbsp;</span>}
            {item.filing_date && <span>Filed: {item.filing_date}&nbsp;&#x2022;&nbsp;</span>}
            {item.grant_date && <span>Granted: {item.grant_date}&nbsp;&#x2022;&nbsp;</span>}
          </div>
        )}

        {item?.country && (
          <div className="detail-item">
            <LocationOnOutlinedIcon className="detail-icon-" style={{ color: '#FF6666' }} />
            {item.country}
          </div>
        )}

        {item?.abstract && (
          <div style={{ padding: '0 10px' }}>
            <h2 className="detail-title">Abstract</h2>
            <p style={{ margin: 0, textAlign: 'justify' }}>{item.abstract}</p>
            <br></br>
          </div>
        )}

        {item?.images?.length > 0 && (
          <div style={{ paddingBottom: '20px' }}>
            <h2 className="detail-title">Images</h2>
            <div style={{ display: 'flex', width: '100%', overflowX: 'scroll' }}>
              {item.images?.map((i, index) => (
                <img
                  key={index}
                  src={i}
                  style={{
                    border: '2px solid black',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    height: '250px',
                    marginRight: '10px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                  }}
                  width="contains"
                  alt="patent"
                />
              ))}
            </div>
          </div>
        )}

        {item?.pdf && (
          <div className="detail-item">
            <PictureAsPdfOutlinedIcon className="detail-icon-" />
            <a
              href={
                item.pdf.startsWith('http://') || item.pdf.startsWith('https://')
                  ? item.pdf
                  : `https://${item.pdf}`
              }
              target="_blank"
            >
              {item.title + '.pdf'}
            </a>
          </div>
        )}

        {item?.classifications && (
          <div>
            <p>
              <strong>Classifications</strong>
            </p>
            <table>
              <tbody>
                {item.classifications.map((i, index) => (
                  <tr key={index} style={{ paddingLeft: '15px', fontSize: '13px' }}>
                    <td style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                      {i?.code}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </td>
                    <td style={{ paddingTop: '5px', paddingBottom: '5px' }}>{i?.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {item?.cited_by?.original?.length > 0 && (
        <>
          <h4>Citations</h4>
          <div>
            {item.cited_by.original.map((citation, index) => (
              <Card
                key={index}
                category={'patents'}
                details={citation}
                cardHeader={'PATENT'}
                icons={icons}
                dotColor={'orange'}
                vertical_id={item.vertical_id}
                depth={1}
              />
            ))}
          </div>
        </>
      )}

      {item?.similar_documents?.length > 0 && (
        <>
          <h4>Similar Documents</h4>
          <div>
            {item.similar_documents.map(
              (citation, index) =>
                citation?.is_patent && (
                  <Card
                    key={index}
                    category={'patents'}
                    details={citation}
                    cardHeader={'PATENT'}
                    icons={icons}
                    dotColor={'orange'}
                    vertical_id={item.vertical_id}
                    depth={1}
                  />
                )
            )}
          </div>
        </>
      )}

      {item?.patent_citations?.original?.length > 0 && (
        <>
          <h4>References</h4>
          <div>
            {item.patent_citations.original.map((citation, index) => (
              <Card
                key={index}
                category={'patents'}
                details={citation}
                cardHeader={'PATENT'}
                icons={icons}
                dotColor={'orange'}
                vertical_id={item.vertical_id}
                depth={1}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
export default PatentPage;
